<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Provinces"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/provinces'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="address" rules="" v-slot="{ errors }">
                 <div class="label-base pb-1">Lugar</div>
                <v-text-field
                   id="pac-input"
                  :error-messages="errors"
                  v-model="data.address"
                  label="Lugar"
                  solo
                    hide-details="auto"
                    class="input-base"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
                <GoogleMapLoader v-on:select="changeAddress" :show-map="false" style="height: 300px"
                :sendCoordinates="sendCoordinates" 
                :sendState="sendState"
                :sendCity="sendCity" />
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
             <v-col class="py-0 px-2">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  solo
                    hide-details="auto"
                    class="input-base"
                  label="Nombre"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
             <v-col class="py-0 px-2">
              <ValidationProvider ref="price" rules="required|without_decimals|non_negative" v-slot="{ errors }">
                 <div class="label-base pb-1">Precio</div>
                <v-text-field
                  :error-messages="errors"
                  v-model.number="data.price"
                  solo
                    hide-details="auto"
                    class="input-base custom-number"
                  :type="'Number'"
                  label="Precio"
                  >
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.price++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.price = Math.max(0, data.price - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import GoogleMapLoader from "@/components/maps/GoogleMapLoader";

extend('numberpositivo', {
  validate: value => {
    return value > 0;
  },
  message: 'El campo debe ser mayor a 0.'
});

extend('without_decimals', {
  validate: value => {
    return value % 1 === 0;
  },
  message: 'El valor no debe tener decimales'
});

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, ValidationObserver, GoogleMapLoader },
  data() {
    return {
      storeName: "Provinces",
      title: "Añadir provincias",
      data: {
        name:"",
        price: "",
        address: '',
        latitude:'',
        longitude:'',
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Provinces.status,
    }),
  },
  watch: {

  },
  methods: {
    sendCoordinates(lat, lng) {
      this.data.latitude = lat;
      this.data.longitude = lng;
    },
    sendState(state){
      this.data.name = state;
    },
    sendCity(city){
      this.data.name = city;
    },
    changeAddress(val) {
      this.data.address = val;
    }
  },
};
</script>
